import apiClient from "../api/apiClient"

export interface CreditPayment {
  _id: string
  company_id: string
  customer_id: { _id: string; name: string }
  bill_id: { _id: string; customer_name: string; summary: { net_payable: number }; payment_status?: string; paid_amount?: number; returned_amount?: number }
  load_form_id: string | null
  amount_paid: number
  payment_date: string
  collected_by: { _id: string; name: string }
  remarks: string
  is_deleted: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateCreditPaymentData {
  bill_id: string
  amount_paid: number
  payment_date?: string
  remarks?: string
  payment_account?: 'cash' | 'bank'
  bank_account_id?: string
}

export const creditPaymentService = {
  async createPayment(data: CreateCreditPaymentData): Promise<{
    message: string
    payment: CreditPayment
    bill_payment_status: { payment_status: string; paid_amount: number; returned_amount: number }
  }> {
    const response = await apiClient.post('/admin/credit-payments', data)
    return response.data
  },

  async getPayments(params?: {
    customer_id?: string
    bill_id?: string
    from?: string
    to?: string
  }): Promise<{ results: CreditPayment[] }> {
    const response = await apiClient.get('/admin/credit-payments', { params })
    return response.data
  },

  async deletePayment(id: string): Promise<{ message: string; bill_payment_status: { payment_status: string; paid_amount: number; returned_amount: number } }> {
    const response = await apiClient.delete(`/admin/credit-payments/${id}`)
    return response.data
  },
}
